import React from 'react'
import { /* Container,  */Carousel } from '../../../components'
import { Link } from 'react-router-dom'
import { CardFeatured } from '.'
import { useSelector } from 'react-redux'

const Featured = ({embed, defaultItems}) => {
  const raw = useSelector(state => state.blogs.data)
  const featureds = raw.filter(r => r.featured)
  const data = defaultItems ? defaultItems : featureds.length === 0 ? raw.slice(0, 6) : featureds

  return data && data.length > 0 ? (
    <div className="overflow-x-hidden">
      {/* Cards */}
      <div className={`lg:-mx-4 text-gray-900 ${embed ? '' : 'mb-4 lg:mb-8'} featured-carousel`}>
        <Carousel
          autoplay={true}
          loop={true}
        >
          {
            data.map((d, index) => (
              <div className="w-1/2 lg:w-1/4 px-5 lg:px-4 lg:mb-4 h-full" key={index}>
                <Link to={`/blog/${d.id}/detail`}>
                  <CardFeatured data={d} featured={true} embed={embed}/>
                </Link>
              </div>
            ))
          }
        </Carousel>
      </div>
    </div>
  ) : <></>
}

export { Featured }
